import 'imagesloaded/imagesloaded.pkgd.min.js';
import simpleParallax from 'simple-parallax-js';
import AOS from 'aos';

export default {
  init() {
    
    /* eslint-disable */




    try {
      $('.wr-minicart-toggle').click(function(){
        $(".wr-minicart").toggle();
      });
      var woocarousel = $('.woocommerce_carousel').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        groupCells: true,
      });
      document.addEventListener('aos:in:woocarousel', () => {
        woocarousel.flickity('resize');
      });
    } catch (error) {}
    /* eslint-enable */
  },
  finalize() {
    AOS.init();

    $('#searchForm').on('shown.bs.collapse', function () {
    // focus input on collapse
    $("#search").focus()
  })

    $('#searchForm').on('hidden.bs.collapse', function () {
    // focus input on collapse
    $("#search").blur()
  })

    var image = document.getElementsByClassName('enable-parallax');
    new simpleParallax(image, {
      delay: .3,
      transition: 'cubic-bezier(0,0,0,1)',
      scale: 1.25,
    });

    image = document.getElementsByClassName('enable-parallax-right');
    new simpleParallax(image, {
      delay: .4,
      transition: 'cubic-bezier(0,0,0,1)',
      orientation: 'right',
      scale: 1.05,
    });

    image = document.getElementsByClassName('enable-parallax-left');
    new simpleParallax(image, {
      delay: .4,
      transition: 'cubic-bezier(0,0,0,1)',
      orientation: 'left',
      scale: 1.05,
    });

    $( window ).resize(function() {
     blockPlacement();
   });

    function blockPlacement(){
      if ( $( '.shift-block-down' ).length ) {
        $( '.shift-block-down' ).each(function() {

          $(this).prev('.o-section').find('.section-padding-bottom').height($(this).outerHeight()/2);
          $(this).next('.o-section').find('.section-padding-top').height($(this).outerHeight()/2);

        });
      }

    }

    blockPlacement();
    $('main').imagesLoaded( function() {
      blockPlacement();
            $('.background-carousel').flickity({
        fade:true,
        pageDots: false,
        prevNextButtons: false,      
        autoPlay: 6000, 
        wrapAround: true,
        pauseAutoPlayOnHover: false,
      });
    });

    setTimeout(function(){ 
      $('.carousel').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
      });
    }, 300);

    jQuery(document).ready(function ($) {
      $('#productTab a:first').tab('show')
    });

// Responsive tables
/* eslint-disable */

function responsiveTable( selector, force ) {
  var me = this,
  tables = $( selector ? selector : 'table.responsive'),
  table, ths, th, trs, tds, td, text, it; 

  if ( tables.length > 0 ) {

    for ( var i = 0, l = tables.length; i < l; i++ ) {
      table = $( tables[ i ] );
      if ( table.attr( 'data-type' ) && !force ) {
        continue;
      }
      table.attr( 'data-type', 'responsive' );
      trs = table.find( '> thead > tr, > tbody > tr, > tr' );
      ths = trs.find( '> th' );
      for ( var ii = 0, ll = trs.length; ii < ll; ii++ ) {
        tds = $( trs[ ii ] ).find( '> td' );
        for ( var iii = 0, lll = tds.length; iii < lll; iii++ ) {
          th = ths[ iii ];
          it = $( tds[ iii ] );
          text = th.textContent || th.innerText || '';
          if ( force ) {
            it.find( 'span[data-type="responsive"]' ).remove();
          }
          td = it.prepend( '<span data-type="responsive">' + text + '</span>' );
        }
      }
    }
  }
}

responsiveTable();


},
};

// JavaScript to be fired on all pages
var toggleAffix = function(affixElement) {


  if ($(document).scrollTop() > 0){
    affixElement.addClass('affix');
  }
  else {
    affixElement.removeClass('affix');
  }
};


$('.complete-link').click(function() {
  window.location = $(this).find('a').attr('href');
  return false;
});

$('[data-toggle="affix"]').each(function() {
  var ele = $(this);

  $(window).on('scroll resize', function() {
    toggleAffix(ele);
  });
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js